export const SESSION_REFRESH_FREQUENCY_MS = 1000 * 60 * 3;
export const CONTACT_EMAIL = 'container.examinations@portvancouver.com';
export const CONTAINER_CEF_VENTILATION_DELIVERED = 'CONTAINER_CEF_VENTILATION_DELIVERED';
export const VENTILATION_STAGING_END = 'ventilationStagingEnd';
export const AT_TCEF = 'At TCEF';